export class RecoverPasswordNotFoundError extends Error {
  public constructor() {
    super()

    this.message = 'errors.recoverPasswordNotFound'
  }
}
